import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"
import classNames from "classnames"

import { urlifyPath } from "../../../utils/paths"
import SmartLink from "../../layout/SmartLink/SmartLink"
import { InlineText } from "../../Typography/Typography"

import { breadcrumbs, linkSeparator } from "./styles.module.scss"

const ListItem = ({ text, path, clickEvent }) =>
  path ? (
    <>
      <SmartLink to={path} clickEvent={clickEvent}>
        <InlineText brand>{text}</InlineText>
      </SmartLink>
      <InlineText className={linkSeparator}>/</InlineText>
    </>
  ) : (
    <InlineText>{text}</InlineText>
  )

ListItem.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string,
  clickEvent: PropTypes.shape({
    name: PropTypes.string,
    properties: PropTypes.object,
  }).isRequired,
}

ListItem.defaultProps = {
  path: undefined,
}

const breadcrumbClickEvent = (text, path) => ({
  name: "SEO - Filtered Directory - Breadcrumb Link Clicked",
  properties: {
    "Breadcrumb Text": text,
    "Breadcrumb URL": path,
  },
})

const Breadcrumbs = ({ links }) => {
  const cleanLinks = links.filter((l) => l !== null)
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: cleanLinks.map(({ path, text }, i) => ({
                "@type": "ListItem",
                position: i + 1,
                name: text,
                item: urlifyPath(path),
              })),
            },
            null,
            2,
          )}
        </script>
      </Helmet>
      <div className={classNames(breadcrumbs)}>
        {cleanLinks.map(({ path, text }, i) => (
          <ListItem
            key={`breadcrumb-slash-link-${path}`}
            text={text}
            path={i === cleanLinks.length - 1 ? null : path}
            clickEvent={breadcrumbClickEvent(text, path)}
          />
        ))}
      </div>
    </>
  )
}

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

Breadcrumbs.defaultProps = {}

export default Breadcrumbs
